import React from 'react';
import './EURegistrationAlert.css';

const EURegistrationAlert = ({ locationInfo, onClose }) => {
  return (
    <div className="eu-registration-alert">
      <div className="alert-content">
        <div className="alert-header">
          <span className="material-symbols-outlined warning-icon">public_off</span>
          <h2>Registrierung nur aus Europa möglich</h2>
        </div>
        
        <div className="alert-message">
          <p>
            Aus Sicherheitsgründen ist eine Registrierung bei HiFiCouch.World nur aus europäischen Ländern möglich.
          </p>
          
          {locationInfo && (
            <div className="location-info">
              <p>
                <strong>Ihr Standort:</strong> {locationInfo.country || 'Unbekannt'}
              </p>
              {locationInfo.userAgentSuspicious && (
                <p className="suspicious-notice">
                  <span className="material-symbols-outlined">error</span>
                  Verdächtiger Browser oder automatisierter Zugriff erkannt
                </p>
              )}
            </div>
          )}
          
          <p className="policy-explanation">
            Diese Einschränkung dient dem Schutz unserer Community vor Fake-Accounts und hilft uns, 
            die Qualität und Sicherheit der Plattform zu gewährleisten.
          </p>
        </div>
        
        <div className="alert-actions">
          <button onClick={onClose} className="close-alert">
            <span className="material-symbols-outlined">close</span>
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
};

export default EURegistrationAlert;